import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';
import { MarkdownImage } from '@vs-shop/image-link/MarkdownImage';
import { MarkdownContent } from '@vs-shop/ui/markdown';

import { MarkdownErrorBoundary } from '../../client/error/MarkdownErrorBoundary';

type Props = Omit<ComponentProps<'div'>, 'children'> & {
  children: string;
};

/**
 * rcprofi's markdown renderer: this tenant's stylesheet around the shared
 * plugin chain, with this tenant's Sentry-reporting error boundary around the
 * chain alone — a crash there still leaves this element and its class in
 * place for the boundary's fallback to render into.
 *
 * Native `div` props ride the spread so a part that paints THIS element — the
 * clamp of `@vs-shop/ui/collapsibleBlock` above all — can hand it a class, a
 * `data-slot` and the ref it measures.
 */
export default function Markdown({ children, className, ...props }: Props) {
  return (
    <div className={clsxm('markdown-style', className)} {...props}>
      <MarkdownErrorBoundary>
        <MarkdownContent image={MarkdownImage}>{children}</MarkdownContent>
      </MarkdownErrorBoundary>
    </div>
  );
}
